// this is an autogenerated file from App/Account/Content/Settings/Content/ConnectApps/Sync/Content/SyncPatients/mutation.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Settings_Content_ConnectApps_Sync_Content_SyncPatients(
  $sync_id: uuid!
  $matched: [apps_sync_matching_start_matched_item!]!
) {
  apps_sync_matching_start(sync_id: $sync_id, matched: $matched) {
    ok
    sync_id
  }
}

`